import { object, string, array } from "yup";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    description: string().required(requiredText),
    contractIds: array(),
    userIds: array(),
  });
};
